import { render, staticRenderFns } from "./MoverItens.vue?vue&type=template&id=1eb673a2&scoped=true&lang=pug"
import script from "./MoverItens.vue?vue&type=script&lang=js"
export * from "./MoverItens.vue?vue&type=script&lang=js"
import style0 from "./MoverItens.vue?vue&type=style&index=0&id=1eb673a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb673a2",
  null
  
)

export default component.exports